import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { getHistoryQueryKey, useUploadFileService } from "store/backend/apiHooks";
import tokenUtils from "utils/tokenUtils";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";

const useFileUpload = (scriptId) => {
  const userId = tokenUtils.getUploaderUserId();
  const queryClient = useQueryClient();
  const { mutate: uploadFileService, isPending } = useUploadFileService();
  const { openSnackbar } = useSnackbarContext();
  const [selectedFile, setSelectedFile] = useState(null);

  const clearFile = () => setSelectedFile(null);

  const upload = (fileInputRef) => {
    if (!selectedFile || !scriptId || !userId) {
      return;
    }

    uploadFileService(
      { selectedFile, userId, scriptId },
      {
        onSuccess: (data) => {
          if (!data?.uploaded_file_id) {
            openSnackbar("Upload failed. Please try again.", "error");
            return;
          }

          openSnackbar("File uploaded successfully!", "success");
          queryClient.invalidateQueries({ queryKey: getHistoryQueryKey(userId) });
          setSelectedFile(null);

          if (fileInputRef?.current) {
            fileInputRef.current.value = "";
          }
        },
        onError: (err) => {
          openSnackbar(err.message || "Upload failed", "error");
        },
      }
    );
  };

  return {
    selectedFile,
    setSelectedFile,
    upload,
    isPending,
    clearFile,
    userId,
  };
};

export default useFileUpload;
